import { gql } from 'apollo-angular';

export const SIGN_UP = gql`
  mutation signUp($userSignUpDetailsInput: SignupCustomerInput!) {
    signUp(userSignUpDetailsInput: $userSignUpDetailsInput) {
      customerId
    }
  }
`;

export const SIGN_IN = gql`
  mutation signIn($authCredentialInput: AuthCredentialInput!) {
    signIn(authCredentialInput: $authCredentialInput) {
      accessToken
      cartId
      customerId
    }
  }
`;

export const CONTACT_US = gql`
  mutation createContactus($createContactusInput: CreateContactusInput!) {
    createContactus(createContactusInput: $createContactusInput) {
      message
    }
  }
`;

export const SEND_CONSULTATION = gql`
  mutation sendConsultation($sendConsultationInput: ConsultationInput!) {
    sendConsultation(sendConsultationInput: $sendConsultationInput) {
      message
    }
  }
`;

export const DELETE_CONSULTATION = gql`
  mutation deleteConsultation(
    $deleteConsultationInput: DeleteConsultationInput!
  ) {
    deleteConsultation(deleteConsultationInput: $deleteConsultationInput) {
      message
    }
  }
`;

export const MAKE_AN_APPOINTMENT = gql`
  mutation bookAnAppointment($createAppointmentInput: CreateAppointmentInput!) {
    bookAnAppointment(createAppointmentInput: $createAppointmentInput) {
      message
    }
  }
`;

export const UPDATE_CUSTOMER_DETAILS = gql`
  mutation updateCustomerDetails(
    $updateBuyerDetails: UpdateCustomerDetailsInput!
  ) {
    updateCustomerDetails(updateBuyerDetails: $updateBuyerDetails) {
      customerId
    }
  }
`;

export const FORGET_PASSWORD = gql`
  mutation forgetPassword($forgetPasswordInput: ForgetPasswordInput!) {
    forgetPassword(forgetPasswordInput: $forgetPasswordInput) {
      message
    }
  }
`;

export const CREATE_OFFER_RESERVATION = gql`
  mutation createOfferReservation(
    $createOfferReservationInput: CreateOfferReservationInput!
  ) {
    createOfferReservation(
      createOfferReservationInput: $createOfferReservationInput
    ) {
      offerReservationId
      name
      phone
      offerName
      createdAt
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($resetUserPasswordInput: ResetUserPasswordInput!) {
    resetPassword(resetUserPasswordInput: $resetUserPasswordInput) {
      message
    }
  }
`;

export const CLEARCART = gql`
mutation clearCart($cartId: String!) {
  clearCart(cartId:$cartId){
    cartId 
    tax
    price
    totalPrice
    items{
    cartItemId 
    offer_code 
    lst_price 
    qty 
    arabic_name 
    english_name 
    image
    }
  }
}
`

export const CREATECART = gql`
mutation createCart($customerId:String) {
  createCart(customerId : $customerId) {
    cartId 
    tax
    price
    totalPrice
    items{
    cartItemId 
    offer_code 
    lst_price 
    qty 
    arabic_name 
    english_name 
    image
    }
  }
}
`

export const MIGRATECLIENTCARTWITHCUSTOMERCART= gql`
mutation migrateClientWithCustomer($clientCartId: String! , $customerCartId: String!) {
  migrateClientWithCustomer(clientCartId : $clientCartId , customerCartId : $customerCartId) {
    cartId 
    tax
    price
    totalPrice
    items{
    cartItemId 
    offer_code 
    lst_price 
    qty 
    arabic_name 
    english_name 
    image
    }
  }
}
`

export const ADDTOCARTORINCREASE = gql`
mutation addItemToCartOrIncrement($input: AddToCartInput!) {
  addItemToCartOrIncrement(input:$input){
    cartId 
    tax
    price
    totalPrice
    items{
    branch
    cartItemId 
    offer_code 
    lst_price 
    qty 
    arabic_name 
    english_name 
    image
    product_id
    }
  }
}
`

export const DELETECARTITEM = gql`
mutation deleteCartItem($cartItemId: String! , $cartId: String!) {
  deleteCartItem(
    cartId:$cartId,
    cartItemId:$cartItemId
  ){
    cartId 
    tax
    price
    totalPrice
    items{
      cartItemId 
      offer_code 
      lst_price 
      qty 
      arabic_name 
      english_name 
      image
      }
  }
}
`
export const DECREASECARTITEM = gql`
mutation decrementCartItem($cartItemId: String! , $cartId: String!) {
  decrementCartItem(cartId:$cartId,cartItemId:$cartItemId){
    cartId 
    tax
    price
    totalPrice
    items{
      branch
      cartItemId 
      offer_code 
      lst_price 
      qty 
      arabic_name 
      english_name 
      image
      }
  }
}
`

export const UPDATE_CUSTOMER_EMAIL = gql`
  mutation updateCustomerEmail(
    $updateCustomerEmailInput: UpdateCustomerEmailInput!
  ) {
    updateCustomerEmail(updateCustomerEmailInput: $updateCustomerEmailInput) {
      message
    }
  }
`;

export const CHANGE_CUSTOMER_PASSWORD = gql`
  mutation changeCustomerPassword($changePasswordInput: ChangePasswordInput!) {
    changeCustomerPassword(changePasswordInput: $changePasswordInput) {
      customerId
    }
  }
`;

export const APPLY_JOB = gql`
  mutation storeJobApplicant($storeJobApplicantInput: StoreJobApplicantInput!) {
    storeJobApplicant(storeJobApplicantInput: $storeJobApplicantInput) {
      message
    }
  }
`;

export const REPLAY_CONSULTATION = gql`
  mutation createConsultationReply(
    $replyConsultationInput: ConsultationReplyInput!
  ) {
    createConsultationReply(replyConsultationInput: $replyConsultationInput) {
      consultationId
      userId
      commentByUserType
      content
    }
  }
`;

export const CREATE_FORM_RESPONSE = gql`
  mutation CreateFormResponse(
    $createFormResponseInput: CreateFormResponseInput!
  ) {
    createFormResoponse(createFormResponseInput: $createFormResponseInput) {
      formResponseId
      formId
      formSnapshot
      data
      specialOffersValues
    }
  }
`;
